import '@mui/lab/themeAugmentation'

import { theme } from './theme'
import { components } from './components'

theme.components = components

export { theme }
